export default __webpack_public_path__ + "static/media/Layer-erp.2412a723.png";